import React from 'react';

import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import background from '../../assets/clouds.jpg';

export default function Parallax(props) {
    const useStyles = makeStyles((theme) => ({
        root: {
            minHeight: props.header ? '30vh' : '100%',
            backgroundImage: `url(${background})`,
            backgroundAttachment: "fixed",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        },
        colorLayer: {
            width: '100%',
            height: '100%'
        },
        content: {
            padding: theme.spacing(4),
            minHeight: props.header ? '30vh' : '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        }
    }))
    const classes = useStyles();


    return (
        <div className={classes.root}>
            <div
                className={clsx(classes.content, {
                    [classes.colorLayer]: props.overlay
                })}>
                {props.children}
            </div>
        </div>
    )
}